import axios from "@/axios";

const getDefaultState = () => {
  return {
    form: {},
    responseData: null,
    setResponse: [],
    groupedOrderDetails: null,
  };
};

const moduleBulletPointGenerator = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getForm(state) {
      return state.form;
    },
    getResponseData(state) {
      return state.responseData;
    },
    getBulletPointGeneratorOrder(state) {
      return state.setResponse;
    },
    getGroupedOrderDetails(state) {
      return state.groupedOrderDetails;
    },
    selectedWorkspace: state => state.selectedWorkspace,
  },
  mutations: {
    setForm(state, form) {
      state.form = { ...form };
    },
    setResponse(state, responseData) {
      state.responseData = responseData;
    },
    setGroupedOrderDetails(state, groupedOrderDetails) {
      state.groupedOrderDetails = groupedOrderDetails;
    },
    setPollingInterval(state, interval) {
      state.pollingInterval = interval;
    },
    clearPollingInterval(state) {
      if (state.pollingInterval) {
        clearInterval(state.pollingInterval);
        state.pollingInterval = null;
      }
    },
  },
  actions: {
    async createRequest({ commit, rootGetters, dispatch }, form) {
      try {
        const formData = new FormData();

        formData.append('files', form.xlsxData);
        formData.append('language', form.languages);
        formData.append('order_title', form.order_title);
        if (rootGetters.selectedWorkspace?.id) {
          formData.append('workspace_id', rootGetters.selectedWorkspace?.id);
        }
        formData.append('translate_from', form.languages);

        dispatch('startPolling');

        const response = await axios.post('tools/bullet_point_generator', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        commit('setResponse', response.data);

        dispatch('startPolling');

        return response;
      } catch (error) {
        console.error('Errore nella richiesta:', error);
        throw error;
      }
    },
  },

};

export default moduleBulletPointGenerator;
